module.exports = __webpack_public_path__ + "img/pagination-new-current-icon.cb199300.svg";